import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'en',
    // 未対応言語（fr 等）は fallbackLng の en に落とす
    supportedLngs: ['en', 'ja'],
    detection: {
      // ブラウザ検出値（ja-JP / en-US 等）を ja / en に正規化する。
      // Header の Select の選択肢と一致させないと初期表示が空になる。
      convertDetectedLanguage: (lng: string) => lng.split('-')[0],
    },
    returnEmptyString: false,
    resources: {
      en: {
        translation: require('./en.json'),
      },
      ja: {
        translation: require('./ja.json'),
      },
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'span'],
    },
  });

export default i18n;
